// Consultation type a doctor is registered for (assigned by the admin when the
// account is created). Mirrors the `ConsultationType` enum behind the auth
// service's `users.consultation_type` column.
export const DOCTOR_CONSULTATION_TYPES = Object.freeze({
  ONLINE: "video",
  HOME: "onsite",
  // Legacy combined mode: new doctors are single-mode, but older accounts may
  // still carry it.
  ONLINE_AND_HOME: "video-onsite",
});

// sessionStorage key holding the consultation type returned at login.
export const CONSULTATION_TYPE_STORAGE_KEY = "usr_consultation_type";
